import axiosClient from '../../api/axiosClient.js';
import { fetchPageData } from '../../api/utils.js';

export async function getClassificationScores({gameId, completed} = {}) {
  return fetchPageData(`/api/classification/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getNormalScores({gameId, completed} = {}) {
  return fetchPageData(`/api/normal/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getPrinciplesScores({gameId, completed} = {}) {
  return fetchPageData(`/api/principles/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getBalancedEquationScores({gameId, completed} = {}) {
  return fetchPageData(`/api/equation/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getClassificationScoresByQuestion(gameId) {
  return fetchPageData(`/api/classification/scores/by-question/?game=${gameId ? `?game=${gameId}` : ''}`);
}

export async function getNormalScoresByQuestion(gameId) {
  return fetchPageData(`/api/normal/scores/by-question/?game=${gameId ? `?game=${gameId}` : ''}`);
}

export async function getPrinciplesScoresByQuestion(gameId) {
  const response = await axiosClient.get(`/api/principles/scores/principles/?game=${gameId ? `?game=${gameId}` : ''}`);
  return response.data;
}

export async function getBalancedEquationScoresByQuestion(gameId) {
  return fetchPageData(`/api/equation/scores/by-question/?game=${gameId ? `?game=${gameId}` : ''}`);
}

export async function getClassificationScoresInsights(gameId) {
  return fetchPageData(`/api/classification/scores/insights/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getNormalScoresInsights(gameId) {
  return fetchPageData(`/api/normal/scores/insights/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getEquationScoresInsights(gameId) {
  return fetchPageData(`/api/equation/scores/insights/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getPrinciplesScoresPrinciples(gameId) {
  const response = await axiosClient.get(`/api/principles/scores/principles/${gameId ? `?game=${gameId}` : ''}`);
  return response?.data;
}

export async function getGames() {
  return fetchPageData(`/api/games/games/`);
}

export const gamesQuery = () => {
  return {
    queryKey: ['games'],
    queryFn: async () => getGames(),
    refetchOnWindowFocus: false
  };
};